let playerItems = null;
$(document).ready(function () {
	const listId = $('.playlist').attr('data-listId');
	if (!listId) return null;
	$.get(base_url + "/playlistitem/" + listId)
	.done(function(resp) {
		playerItems = resp;
	})
	.fail(function(resp) {
		// console.log('Error', resp['responseJSON'])
	})
	.always(function(){
		if (!playerItems || playerItems.length < 1 || typeof playerItems === 'undefined') return;
		if (typeof (YT) == 'undefined' || typeof (YT.Player) == 'undefined') {
			// 1. Download player API code
			let tag = document.createElement('script')
			let firstScript = document.getElementsByTagName('script')[0]
			tag.src = 'https://www.youtube.com/iframe_api';
			tag.id = 'youtube-api';
			firstScript.parentNode.insertBefore(tag, firstScript)
		}
	})
})

// 2. Will execute as soon as the player API code downloads
window.onYouTubePlayerAPIReady = function () {
	// 3. create YT Player
	const createPlayer = function(item, playerId) {
		return new YT.Player(playerId, {
			videoId: item.videoId,
			title: item.title,
		});
	}
	playerItems.forEach((item, idx) => {
		const playerId = `player${idx}`;
		let slide = `<div class="swiper-slide" data-id="${idx}"><div id="${playerId}"></div></div>`
		$('.swiper-wrapper').append(slide);
		createPlayer(item, playerId);
	});

	if ($('.swiper-slide').length < 1) {
		$('.playlist').addClass('d-none')
		return;
	}
	$('.playlist').removeClass('d-none')
	const swiper = new Swiper(".swiper", {
		centeredSlides: true,
		initialSlide: 0,
		slidesPerView: 1,
		spaceBetween: 25,
		speed: 500,
		watchSlidesVisibility: true,
		slideToClickedSlide: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		breakpoints: {
			550: {
				centeredSlides: true,
				initialSlide: 0,
				slidesPerView: 2,
				spaceBetween: 10,
			},
			700: {
				centeredSlides: true,
				initialSlide: 0,
				slidesPerView: 2,
				spaceBetween: 25,
				},
			1000: {
				centeredSlides: true,
				initialSlide: 0,
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
		on: {
			init: function () {
				this.params._setTitle(this.activeIndex);
			},
			slideChangeTransitionEnd: function () {
				this.params._setTitle(this.activeIndex);
			},
			slideNextTransitionStart: function () {
				this.$el.addClass('swiper-active').removeClass('swiper-default');
			},
		},
		_setTitle(id) {
			const title = `<a href="${playerItems[id]['srcWatch']}" target="_blank">${playerItems[id]['title']}</a>`
			$('.videoTitle').html(title)
		}
	});
}
